import { useAuthState } from '@/components/context/AuthContext';
import { Outlet } from 'react-router-dom';

const RouteOutlet = () => {
  const { isAuthenticated } = useAuthState();

  if (!isAuthenticated) {
    return null;
  }

  return <Outlet />;
};

export default RouteOutlet;